const updateActiveFilters = (activeFilters: string[], change: Record<string, boolean>) => {
  const result = new Set(activeFilters);
  for (const [filter, enabled] of Object.entries(change)) {
    if (enabled) result.add(filter);
    else result.delete(filter);
  }
  return [...result];
};

export default updateActiveFilters;
